module.exports = __webpack_public_path__ + "img/guy-with-half-sleeve-3d-jesus-tattoo-design.jpg";